import React from 'react';
import {
  Heading as ChakraHeading,
  type HeadingProps as ChakraHeadingProps
} from '@chakra-ui/react';

type OciHeadingSize =
  | 'xxsmall'
  | 'xsmall'
  | 'small'
  | 'medium'
  | 'large'
  | 'xlarge'
  | 'xxlarge'
  | 'jumbo';

export interface HeadingProps extends Omit<ChakraHeadingProps, 'size'> {
  size?: OciHeadingSize;
  variation?: string;
}

export const Heading = React.forwardRef<HTMLHeadingElement, HeadingProps>(
  function Heading({ variation, size, className, ...rest }, ref) {
    return (
      <ChakraHeading
        ref={ref}
        className={className}
        color={variation ? `oci.${variation}` : 'inherit'}
        // Custom sizes are defined in the heading recipe (chakra-theme.ts).
        // Cast needed because Chakra's built-in types don't reflect theme recipes.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        size={size as any}
        {...rest}
      />
    );
  }
);
